import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";
import Button from "designs/v1/components/Button";
import {
  addNomineeApi,
  editNomineeApi,
  getVerifiedAddress,
  getAddressByPincode,
  validateIncomeProof,
} from "designs/v1/pages/ModifyKyc/services";
import { getApiUrl } from "utils";
import {
  THINKREDBLUE_API_URL,
  jsonToFormData,
  validateOnNumber,
  validateOnPaste,
  onInputToUpperCase,
} from "utils";

const AddEditNominee = ({
  activeUserDetail,
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  selectedNominee,
  nomineeList,
  nomineeFormValue,
  setNomineeFormValue,
  isEdit,
  isView,
  setIsLoading,
  handleCloseForm,
  loadNomineeApi,
}) => {
  const { hasNomineeProofValidate } = useSelector((state) => state.theme);
  const RELATIONWITHAPPLICANT = [
    "FATHER",
    "MOTHER",
    "BROTHER",
    "SISTER",
    "SON",
    "DAUGHTER",
    "SPOUSE",
    "OTHERS",
  ];
  const FILE_TYPES = ["JPG", "JPEG", "PNG", "PDF"];
  const timeout = useRef();
  const [isSameAddress, setIsSameAddress] = useState();
  const [isAddress, setIsAddress] = useState(false);
  const [isGuardianAddress, setIsGuardianAddress] = useState(false);
  const nomineeFrontFileRef = useRef();
  const nomineeBackFileRef = useRef();
  const guardianFrontFileRef = useRef();
  const guardianBackFileRef = useRef();

  const [proofOptions, setProofOptions] = useState([
    { name: "PAN", value: "PAN" },
    { name: "Aadhaar", value: "Aadhaar" },
    { name: "Driving License", value: "DrivingLicense" },
    { name: "Passport", value: "Passport" },
    { name: "Voter ID", value: "VoterID" },
    { name: "Other", value: "Other" },
  ]);

  useEffect(() => {
    if (selectedNominee) {
      setNomineeFormValue({
        ...selectedNominee,
        nominee_dob:
          (selectedNominee.nominee_dob &&
            new Date(selectedNominee.nominee_dob)) ||
          "",
        guardian_dob:
          (selectedNominee.guardian_dob &&
            new Date(selectedNominee.guardian_dob)) ||
          "",
        minor: selectedNominee.minor === 1 ? true : false,
      });
    }
  }, [selectedNominee]);

  const onValidate = (values) => {
    const errors = {};
    if (!values.nominee_name) {
      errors.nominee_name = "Nominee name is required";
    }
    if (!values.mobile) {
      errors.mobile = "Mobile number is required";
    }
    if (values.mobile?.length < 10) {
      errors.mobile = "Invalid mobile number";
    }
    if (!values.nominee_dob) {
      errors.nominee_dob = "DOB is required";
    }
    if (!values.relationship_with_applicant) {
      errors.relationship_with_applicant =
        "Relationship with applicant is required";
    }
    if (
      values.relationship_with_applicant === "Others" &&
      !values.other_relationship
    ) {
      errors.other_relationship = "This field is required";
    }
    if (!values.address_line1) {
      errors.address_line1 = "Address is required";
    }
    if (!values.city) {
      errors.city = "City is required";
    }
    if (!values.state) {
      errors.state = "State is required";
    }
    if (!values.country) {
      errors.country = "Country is required";
    }
    if (!values.pincode) {
      errors.pincode = "Pincode is required";
    }
    if (values.type_of_identification && !values.nominee_id_proof) {
      errors.nominee_id_proof = "Front proof is required.";
    }
    if (
      (!values.type_of_identification && values.nominee_id_proof) ||
      (hasNomineeProofValidate === "Yes" && !values.type_of_identification)
    ) {
      errors.type_of_identification = "Proof type is required.";
    }
    if (
      values.type_of_identification &&
      !["PAN", "Other"].includes(values.type_of_identification) &&
      !values.nominee_id_proof_back
    ) {
      errors.nominee_id_proof_back = "Back proof is required.";
    }
    if (!values.share_of_nominee) {
      errors.share_of_nominee = "Nominee share is required.";
    }
    if (parseInt(values.share_of_nominee) === 0) {
      errors.share_of_nominee = "Invalid value";
    }
    if (parseInt(values.share_of_nominee) > 100) {
      errors.share_of_nominee = "Nominee's total shares cannot be greator 100%";
    }
    if (values.minor && !values.guardian_name) {
      errors.guardian_name = "Name is required";
    }
    if (values.minor && !values.guardian_mobile) {
      errors.guardian_mobile = "Mobile number is required";
    }
    if (values.minor && values.guardian_mobile?.length < 10) {
      errors.guardian_mobile = "Invalid mobile number";
    }
    if (values.minor && !values.guardian_dob) {
      errors.guardian_dob = "DOB is required";
    }
    if (
      values.minor &&
      ((!values.id_type && values.guardian_id_proof) ||
        (hasNomineeProofValidate === "Yes" && !values.id_type))
    ) {
      errors.id_type = "Proof type is required.";
    }
    if (values.minor && values.id_type && !values.guardian_id_proof) {
      errors.guardian_id_proof = "Front proof is required.";
    }
    if (
      values.minor &&
      values.id_type &&
      !["PAN", "Other"].includes(values.id_type) &&
      !values.guardian_id_proof_back
    ) {
      errors.guardian_id_proof_back = "Back proof is required.";
    }
    if (values.minor && !values.guardian_address1) {
      errors.guardian_address1 = "Address is required";
    }
    if (values.minor && !values.guardian_city) {
      errors.guardian_city = "City is required";
    }
    if (values.minor && !values.guardian_state) {
      errors.guardian_state = "State is required";
    }
    if (values.minor && !values.guardian_country) {
      errors.guardian_country = "Country is required";
    }
    if (values.minor && !values.guardian_pincode) {
      errors.guardian_pincode = "Pincode is required";
    }
    return errors;
  };

  useEffect(() => {
    if (THINKREDBLUE_API_URL === getApiUrl()) {
      setProofOptions(proofOptions.slice(0, 2));
    }
  }, [proofOptions]);

  const onFileUpload = async (file, name, setFieldValue) => {
    if (!file) {
      setFieldValue(name, "");
      return;
    }
    const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowed_types.includes(file.type)) {
      toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
      setFieldValue(name, "");
      return;
    }
    const fileSize = file.size / 1024 ** 2;
    if (fileSize >= 4) {
      toast.error("Please upload a file smaller than 4 MB");
      setFieldValue(name, "");
      return;
    }
    if (file.type === "application/pdf") {
      setIsLoading(true);
      try {
        const resp = await validateIncomeProof(jsonToFormData({ file }));
        const isEncrypted = resp.data?.message;
        if (isEncrypted) {
          setFieldValue(name, "");
          toast.error("Please upload a file without password protected.");
        } else {
          if (["guardian_id_proof", "guardian_id_proof_back"].includes(name)) {
            setFieldValue("guardian_idproof_file_type", "pdf");
          } else {
            setFieldValue("nominee_idproof_file_type", "pdf");
          }
          setFieldValue(name, file);
        }
        setIsLoading(false);
      } catch (error) {
        setFieldValue(name, "");
        setIsLoading(false);
        toast.error("Internal server error!");
      }
    } else {
      if (["guardian_id_proof", "guardian_id_proof_back"].includes(name)) {
        setFieldValue("guardian_idproof_file_type", "Image");
      } else {
        setFieldValue("nominee_idproof_file_type", "Image");
      }
      setFieldValue(name, file);
    }
  };
  const handleSubmit = async (value) => {
    if (nomineeList.length > 0) {
      let totalShare;
      if (isEdit) {
        let nomineefilter = nomineeList.filter(
          (y) => y.name !== selectedNominee.name
        );
        totalShare = nomineefilter.reduce(
          (sum, { share_of_nominee }) => sum + parseInt(share_of_nominee),
          0
        );
        let newNomineeShare = parseInt(value.share_of_nominee) || 0;
        if (newNomineeShare + totalShare > 100) {
          return toast.error(
            `Error: Nominee's total shares cannot be greator 100%`
          );
        }
      } else {
        totalShare = nomineeList.reduce(
          (sum, { share_of_nominee }) => sum + parseInt(share_of_nominee),
          0
        );
        let newNomineeShare = parseInt(value.share_of_nominee) || 0;
        if (newNomineeShare + totalShare > 100) {
          return toast.error(
            `Error: Nominee's total shares cannot be greator 100%`
          );
        }
      }
    }
    setIsLoading(true);
    const guardianValues = {
      guardian_name: "",
      guardian_mobile: "",
      guardian_email: "",
      guardian_dob: "",
      relationship_with_nomiee: "",
      id_type: "",
      guardian_id_proof: "",
      guardian_id_proof_back: "",
      guardian_idproof_file_type: "",
      guardian_address1: "",
      guardian_address2: "",
      guardian_city: "",
      guardian_state: "",
      guardian_country: "",
      guardian_pincode: "",
    };
    let formValue = { ...value };
    if (!formValue.minor) {
      formValue = { ...value, ...guardianValues };
    }
    console.log(formValue);
    const payload = {
      ...formValue,
      nominee_dob:
        (formValue.nominee_dob &&
          moment(formValue.nominee_dob).format("DD-MM-YYYY")) ||
        "",
      guardian_dob:
        (formValue.guardian_dob &&
          moment(formValue.guardian_dob).format("DD-MM-YYYY")) ||
        "",
      minor: formValue.minor ? "1" : "0",
      request_type: stageScreen,
      doc_name: localStorage.getItem("NomineeRequestNumber"),
    };
    if (isEdit) {
      try {
        payload["id"] = selectedNominee.name;
        if (typeof formValue.nominee_id_proof === "string") {
          payload["samenomineeproof"] = 0;
        } else {
          payload["samenomineeproof"] = 1;
        }
        if (typeof formValue.guardian_id_proof === "string") {
          payload["samenomineeguardianproof"] = 0;
        } else {
          payload["samenomineeguardianproof"] = 1;
        }
        const resp = await editNomineeApi(jsonToFormData(payload));
        console.log("resp", resp);
        setIsLoading(false);
        handleCloseForm();
        loadNomineeApi();
      } catch (error) {
        console.log("err", error);
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Internal server error!"
        );
        setIsLoading(false);
      }
    } else {
      try {
        const resp = await addNomineeApi(jsonToFormData(payload));
        console.log("resp", resp);
        setIsLoading(false);
        handleCloseForm();
        loadNomineeApi();
      } catch (error) {
        console.log("err", error);
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Internal server error!"
        );
        setIsLoading(false);
      }
    }
  };

  const handleGetVerifiedAddress = async (event, setFieldValue) => {
    const { checked } = event.target;
    setIsSameAddress(checked);
    setIsLoading(true);
    if (checked) {
      const payload = { existing_customer: activeUserDetail.existing_customer };
      try {
        const resp = await getVerifiedAddress(payload);
        const data = resp.data?.data;
        console.log("resp", data);
        setIsLoading(false);
        if (data) {
          setFieldValue("address_line1", data.address_line1);
          setFieldValue("pincode", data.pincode);
          setFieldValue("city", data.city);
          setFieldValue("state", data.state);
        }
      } catch (error) {
        const { response } = error;
        console.log("err", response);
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      setFieldValue("address_line1", "");
      setFieldValue("pincode", "");
      setFieldValue("city", "");
      setFieldValue("state", "");
    }
  };

  const getAddressInfo = async (value, setFieldValue, isMinor) => {
    const payload = { pincode: value };
    setIsLoading(true);
    try {
      const resp = await getAddressByPincode(payload);
      const data = resp.data.data;
      setIsLoading(false);
      if (data) {
        if (isMinor) {
          setIsGuardianAddress(true);
          setFieldValue("guardian_city", data.DistrictName);
          setFieldValue("guardian_state", data.StateName);
          setFieldValue("guardian_country", "INDIA");
        } else {
          setIsAddress(true);
          setFieldValue("city", data.DistrictName);
          setFieldValue("state", data.StateName);
          setFieldValue("country", "INDIA");
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    }
  };

  const onSearchPincode = (value, setFieldValue, isMinor) => {
    if (isMinor) {
      setIsGuardianAddress(false);
      setFieldValue("guardian_pincode", value);
    } else {
      setIsAddress(false);
      setFieldValue("pincode", value);
    }
    if (value.length > 5) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        getAddressInfo(value, setFieldValue, isMinor);
      }, 250);
    }
  };

  const getAge = (date) => {
    if (!date) return;
    const age = new Date(Date.now() - date.getTime()).getFullYear() - 1970;
    return age;
  };

  return (
    <div>
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          <Formik
            enableReinitialize={true}
            initialValues={nomineeFormValue}
            validate={onValidate}
            onSubmit={handleSubmit}
          >
            {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
              <Form>
                <div className="row">
                  <div className="col-sm form-group my-2">
                    <label>
                      Name<span className="text-danger">*</span>
                    </label>
                    <Field
                      type="text"
                      name="nominee_name"
                      placeholder="Name"
                      className="form-control"
                      onInput={onInputToUpperCase}
                      disabled={isView}
                    />
                    <ErrorMessage
                      name="nominee_name"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                  <div className="col-sm form-group my-2">
                    <label>Email</label>
                    <Field
                      type="text"
                      name="email_id"
                      placeholder="Email"
                      className="form-control"
                      disabled={isView}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm form-group my-2">
                    <label>
                      Mobile Number<span className="text-danger">*</span>
                    </label>
                    <Field
                      type="text"
                      name="mobile"
                      placeholder="Mobile Number"
                      className="form-control"
                      onPaste={validateOnPaste}
                      onKeyPress={validateOnNumber}
                      maxLength="10"
                      disabled={isView}
                    />
                    <ErrorMessage
                      name="mobile"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    <label>
                      Date Of Birth<span className="text-danger">*</span>
                    </label>
                    <DatePicker
                      placeholderText="dd/mm/yyyy"
                      dateFormat="dd/MM/yyyy"
                      selected={values.nominee_dob}
                      onChange={(date) => {
                        setFieldValue("minor", getAge(date) < 18);
                        setFieldValue("nominee_dob", date);
                      }}
                      customInput={
                        <InputMask
                          style={{ width: "100%" }}
                          mask="99/99/9999"
                        />
                      }
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="form-control"
                      disabled={isView}
                      isClearable={!isView}
                    />
                    <ErrorMessage
                      name="nominee_dob"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 form-group my-2">
                    <label>
                      Relation With Applicant
                      <span className="text-danger">*</span>
                    </label>
                    <Field
                      as="select"
                      name="relationship_with_applicant"
                      type="text"
                      className="form-select"
                      disabled={isView}
                    >
                      <option value={""}>Select an option</option>
                      {RELATIONWITHAPPLICANT.map((item) => {
                        return (
                          <option
                            key={item}
                            value={item}
                          >
                            {item}
                          </option>
                        );
                      })}
                    </Field>
                    <ErrorMessage
                      name="relationship_with_applicant"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                  {values.relationship_with_applicant === "OTHERS" && (
                    <div className="col-sm-6 form-group my-2">
                      <label>
                        Other relationship<span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        name="other_relationship"
                        placeholder="Other relationship"
                        className="form-control"
                        onInput={onInputToUpperCase}
                        disabled={isView}
                      />
                      <ErrorMessage
                        name="other_relationship"
                        className="inline-errormsg my-1"
                        component="div"
                      />
                    </div>
                  )}
                </div>
                <div className="row mx-1">
                  <div className="form-check mt-1">
                    <Field
                      className="form-check-input"
                      type="checkbox"
                      checked={isSameAddress}
                      value={isSameAddress}
                      onChange={(event) =>
                        handleGetVerifiedAddress(event, setFieldValue)
                      }
                      disabled={isView}
                    />
                    <label className="form-check-label">
                      Same as address of applicant
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm form-group my-2">
                    <label>Address Line 1</label>
                    <Field
                      as="textarea"
                      type="text"
                      name="address_line1"
                      placeholder="Address line 1"
                      className="form-control"
                      onInput={onInputToUpperCase}
                      disabled={isView}
                    />
                    <ErrorMessage
                      name="address_line1"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                  <div className="col-sm form-group my-2">
                    <label>Address Line 2</label>
                    <Field
                      as="textarea"
                      type="text"
                      name="address_line2"
                      placeholder="Address line 2"
                      className="form-control"
                      onInput={onInputToUpperCase}
                      disabled={isView}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm form-group my-2">
                    <label>Pincode</label>
                    <Field
                      type="text"
                      name="pincode"
                      placeholder="Pincode"
                      className="form-control"
                      onChange={({ target }) =>
                        onSearchPincode(target.value, setFieldValue, false)
                      }
                      onPaste={validateOnPaste}
                      onKeyPress={validateOnNumber}
                      maxLength="6"
                      disabled={isView}
                    />
                    <ErrorMessage
                      name="pincode"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                  <div className="col-sm form-group my-2">
                    <label>City</label>
                    <Field
                      type="text"
                      name="city"
                      placeholder="City"
                      className="form-control"
                      onInput={onInputToUpperCase}
                      disabled={isView || isAddress}
                    />
                    <ErrorMessage
                      name="city"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm form-group my-2">
                    <label>State</label>
                    <Field
                      type="text"
                      name="state"
                      placeholder="State"
                      className="form-control"
                      onInput={onInputToUpperCase}
                      disabled={isView || isAddress}
                    />
                    <ErrorMessage
                      name="state"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                  <div className="col-sm form-group my-2">
                    <label>Country</label>
                    <Field
                      as="select"
                      name="country"
                      type="text"
                      className="form-select"
                      disabled={isView || isAddress}
                    >
                      {["INDIA"].map((item) => {
                        return (
                          <option
                            key={item}
                            value={item}
                          >
                            {item}
                          </option>
                        );
                      })}
                    </Field>
                    <ErrorMessage
                      name="country"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm form-group my-2">
                    <label>Proof Type</label>
                    <Field
                      as="select"
                      name="type_of_identification"
                      type="text"
                      className="form-select"
                      onChange={({ target }) => {
                        setFieldValue("nominee_id_proof", "");
                        setFieldValue("nominee_id_proof_back", "");
                        setFieldValue("type_of_identification", target.value);
                        if (nomineeFrontFileRef.current) {
                          nomineeFrontFileRef.current.value = "";
                        }
                        if (nomineeBackFileRef.current) {
                          nomineeBackFileRef.current.value = "";
                        }
                      }}
                      disabled={isView}
                    >
                      <option value="">Select Proof Type</option>
                      {proofOptions.map((proof) => (
                        <option
                          key={proof.value}
                          value={proof.value}
                        >
                          {proof.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="type_of_identification"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                  <div className="col-sm form-group my-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <label>Front Proof</label>
                      <div className="file_limit_text">
                        Maximum file size: 4 MB
                      </div>
                    </div>
                    <Field
                      name="nominee_id_proof"
                      className="form-control"
                    >
                      {(props) => (
                        <div className="file-uploader-container">
                          <FileUploader
                            {...props}
                            refProp={nomineeFrontFileRef}
                            handleChange={(file) =>
                              onFileUpload(
                                file,
                                "nominee_id_proof",
                                setFieldValue
                              )
                            }
                            name="file"
                            types={FILE_TYPES}
                            disabled={isView}
                          />
                        </div>
                        // <input
                        //   {...props}
                        //   ref={nomineeFrontFileRef}
                        //   type="file"
                        //   onChange={(e) =>
                        //     onFileUpload(e, "nominee_id_proof", setFieldValue)
                        //   }
                        //   className="form-control"
                        //   disabled={isView}
                        // />
                      )}
                    </Field>
                    <ErrorMessage
                      name="nominee_id_proof"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                    {/* {values?.nominee_id_proof &&
                      typeof values?.nominee_id_proof === "string" && (
                        <img
                          src={`${getApiUrl()}/${values?.nominee_id_proof}`}
                          width="200"
                          height="200"
                          className="mt-2"
                        />
                      )} */}
                  </div>
                </div>
                {values.type_of_identification &&
                  values.type_of_identification !== "PAN" && (
                    <div className="row">
                      <div className="col-sm-6 form-group my-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <label>Back Proof</label>
                          <div className="file_limit_text">
                            Maximum file size: 4 MB
                          </div>
                        </div>
                        <Field
                          name="nominee_id_proof_back"
                          className="form-control"
                        >
                          {(props) => (
                            <div className="file-uploader-container">
                              <FileUploader
                                {...props}
                                refProp={nomineeBackFileRef}
                                handleChange={(file) =>
                                  onFileUpload(
                                    file,
                                    "nominee_id_proof_back",
                                    setFieldValue
                                  )
                                }
                                name="file"
                                types={FILE_TYPES}
                                disabled={isView}
                              />
                            </div>
                            // <input
                            //   {...props}
                            //   ref={nomineeBackFileRef}
                            //   type="file"
                            //   onChange={(e) =>
                            //     onFileUpload(
                            //       e,
                            //       "nominee_id_proof_back",
                            //       setFieldValue
                            //     )
                            //   }
                            //   className="form-control"
                            //   disabled={isView}
                            // />
                          )}
                        </Field>
                        <ErrorMessage
                          name="nominee_id_proof_back"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                    </div>
                  )}
                <div className="row">
                  <div className="col-sm form-group my-2">
                    <label>
                      Allocation of shares<span className="text-danger">*</span>
                    </label>
                    <Field
                      type="text"
                      name="share_of_nominee"
                      placeholder="Share of nominee"
                      className="form-control"
                      onPaste={validateOnPaste}
                      onKeyPress={validateOnNumber}
                      maxLength="3"
                      disabled={isView}
                    />
                    <ErrorMessage
                      name="share_of_nominee"
                      className="inline-errormsg my-1"
                      component="div"
                    />
                  </div>
                  <div className="col-sm my-2">
                    <label></label>
                    <div className="form-check mt-1">
                      <Field
                        className="form-check-input"
                        type="checkbox"
                        name="minor"
                        disabled={isView || getAge(values.nominee_dob) < 18}
                      />
                      <label className="form-check-label">Is Minor</label>
                    </div>
                  </div>
                </div>
                {values.minor && (
                  <>
                    <h5 className="mt-2">Guardian Details</h5>
                    <div className="row">
                      <div className="col-sm form-group mb-2">
                        <label>
                          Name<span className="text-danger">*</span>
                        </label>
                        <Field
                          type="text"
                          name="guardian_name"
                          placeholder="Name"
                          className="form-control"
                          onInput={onInputToUpperCase}
                          disabled={isView}
                        />
                        <ErrorMessage
                          name="guardian_name"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                      <div className="col-sm form-group my-2">
                        <label>Email</label>
                        <Field
                          type="text"
                          name="guardian_email"
                          placeholder="Email"
                          className="form-control"
                          disabled={isView}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm form-group my-2">
                        <label>
                          Mobile Number<span className="text-danger">*</span>
                        </label>
                        <Field
                          type="text"
                          name="guardian_mobile"
                          placeholder="Mobile Number"
                          className="form-control"
                          onPaste={validateOnPaste}
                          onKeyPress={validateOnNumber}
                          maxLength="10"
                          disabled={isView}
                        />
                        <ErrorMessage
                          name="guardian_mobile"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                      <div className="col-sm-6 form-group my-2">
                        <label>
                          Date Of Birth<span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          placeholderText="dd/mm/yyyy"
                          dateFormat="dd/MM/yyyy"
                          selected={values.guardian_dob}
                          onChange={(date) => {
                            setFieldValue("guardian_dob", date);
                          }}
                          customInput={
                            <InputMask
                              style={{ width: "100%" }}
                              mask="99/99/9999"
                            />
                          }
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          disabled={isView}
                          isClearable={!isView}
                        />
                        <ErrorMessage
                          name="guardian_dob"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6 form-group my-2">
                        <label>Relation With Nominee</label>
                        <Field
                          as="select"
                          name="relationship_with_nomiee"
                          type="text"
                          className="form-select"
                          disabled={isView}
                        >
                          <option value={""}>Select an option</option>
                          {RELATIONWITHAPPLICANT.slice(0, 4).map((item) => {
                            return (
                              <option
                                key={item}
                                value={item}
                              >
                                {item}
                              </option>
                            );
                          })}
                        </Field>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm form-group my-2">
                        <label>Address Line 1</label>
                        <Field
                          type="text"
                          name="guardian_address1"
                          placeholder="Address line 1"
                          className="form-control"
                          onInput={onInputToUpperCase}
                          disabled={isView}
                        />
                        <ErrorMessage
                          name="guardian_address1"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                      <div className="col-sm form-group my-2">
                        <label>Address Line 2</label>
                        <Field
                          type="text"
                          name="guardian_address2"
                          placeholder="Address line 2"
                          className="form-control"
                          onInput={onInputToUpperCase}
                          disabled={isView}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm form-group my-2">
                        <label>Pincode</label>
                        <Field
                          type="text"
                          name="guardian_pincode"
                          placeholder="Pincode"
                          className="form-control"
                          onChange={({ target }) =>
                            onSearchPincode(target.value, setFieldValue, true)
                          }
                          onPaste={validateOnPaste}
                          onKeyPress={validateOnNumber}
                          maxLength="6"
                          disabled={isView}
                        />
                        <ErrorMessage
                          name="guardian_pincode"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                      <div className="col-sm form-group my-2">
                        <label>City</label>
                        <Field
                          type="text"
                          name="guardian_city"
                          placeholder="City"
                          className="form-control"
                          onInput={onInputToUpperCase}
                          disabled={isView || isGuardianAddress}
                        />
                        <ErrorMessage
                          name="guardian_city"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm form-group my-2">
                        <label>State</label>
                        <Field
                          type="text"
                          name="guardian_state"
                          placeholder="State"
                          className="form-control"
                          onInput={onInputToUpperCase}
                          disabled={isView || isGuardianAddress}
                        />
                        <ErrorMessage
                          name="guardian_state"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                      <div className="col-sm form-group my-2">
                        <label>Country</label>
                        <Field
                          as="select"
                          name="guardian_country"
                          type="text"
                          className="form-select"
                          disabled={isView || isGuardianAddress}
                        >
                          {["INDIA"].map((item) => {
                            return (
                              <option
                                key={item}
                                value={item}
                              >
                                {item}
                              </option>
                            );
                          })}
                        </Field>
                        <ErrorMessage
                          name="guardian_country"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm form-group my-2">
                        <label>Proof Type</label>
                        <Field
                          as="select"
                          name="id_type"
                          type="text"
                          className="form-select"
                          onChange={({ target }) => {
                            setFieldValue("guardian_id_proof", "");
                            setFieldValue("guardian_id_proof_back", "");
                            setFieldValue("id_type", target.value);
                            if (guardianFrontFileRef) {
                              guardianFrontFileRef.current.value = "";
                            }
                            if (guardianBackFileRef.current) {
                              guardianBackFileRef.current.value = "";
                            }
                          }}
                          disabled={isView}
                        >
                          <option value="">Select Proof Type</option>
                          {proofOptions.map((proof) => (
                            <option
                              key={proof.value}
                              value={proof.value}
                            >
                              {proof.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="id_type"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                      <div className="col-sm form-group my-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <label>Front Proof</label>
                          <div className="file_limit_text">
                            Maximum file size: 4 MB
                          </div>
                        </div>
                        <Field
                          name="guardian_id_proof"
                          className="form-control"
                        >
                          {(props) => (
                            <div className="file-uploader-container">
                              <FileUploader
                                {...props}
                                refProp={guardianFrontFileRef}
                                handleChange={(file) =>
                                  onFileUpload(
                                    file,
                                    "guardian_id_proof",
                                    setFieldValue
                                  )
                                }
                                name="file"
                                types={FILE_TYPES}
                                disabled={isView}
                              />
                            </div>
                            // <input
                            //   {...props}
                            //   ref={guardianFrontFileRef}
                            //   type="file"
                            //   onChange={(e) =>
                            //     onFileUpload(
                            //       e,
                            //       "guardian_id_proof",
                            //       setFieldValue
                            //     )
                            //   }
                            //   className="form-control"
                            //   disabled={isView}
                            // />
                          )}
                        </Field>
                        <ErrorMessage
                          name="guardian_id_proof"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                        {/* {values?.guardian_id_proof &&
                          typeof values?.guardian_id_proof === "string" && (
                            <img
                              src={`${getApiUrl()}/${values?.guardian_id_proof}`}
                              width="200"
                              className="mt-2"
                            />
                          )} */}
                      </div>
                    </div>
                    {values.id_type && values.id_type !== "PAN" && (
                      <div className="row">
                        <div className="col-sm-6 form-group my-2">
                          <div className="d-flex align-items-center justify-content-between">
                            <label>Back Proof</label>
                            <div className="file_limit_text">
                              Maximum file size: 4 MB
                            </div>
                          </div>
                          <Field
                            name="guardian_id_proof_back"
                            className="form-control"
                          >
                            {(props) => (
                              <div className="file-uploader-container">
                                <FileUploader
                                  {...props}
                                  refProp={guardianBackFileRef}
                                  handleChange={(file) =>
                                    onFileUpload(
                                      file,
                                      "guardian_id_proof_back",
                                      setFieldValue
                                    )
                                  }
                                  name="file"
                                  types={FILE_TYPES}
                                  disabled={isView}
                                />
                              </div>
                              // <input
                              //   {...props}
                              //   ref={guardianBackFileRef}
                              //   type="file"
                              //   onChange={(e) =>
                              //     onFileUpload(
                              //       e,
                              //       "guardian_id_proof_back",
                              //       setFieldValue
                              //     )
                              //   }
                              //   className="form-control"
                              //   disabled={isView}
                              // />
                            )}
                          </Field>
                          <ErrorMessage
                            name="guardian_id_proof_back"
                            className="inline-errormsg my-1"
                            component="div"
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div className="d-flex justify-content-end form-group my-4">
                  <div className="mx-2">
                    <Button
                      type="button"
                      title="Close"
                      handleClick={() => handleCloseForm()}
                      loading={isLoading}
                    />
                  </div>
                  {!isView && (
                    <div className="mx-2">
                      <Button
                        title="Submit"
                        disabled={isLoading}
                      />
                    </div>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default AddEditNominee;
